/*
 * Copyright 2020 Spotify AB
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EntityMeta } from '@backstage/catalog-model';
import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { useStarredEntities } from '@backstage/plugin-catalog-react';
import SortIcon from '@material-ui/icons/Sort';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles';
import {
  Box, Button, makeStyles, Typography,
  FormControl,
  MenuItem,
  Select,
  Divider,
  Grid,
} from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import React, { useEffect, useMemo, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import CloseIcon from '@material-ui/icons/Close';
import {
  PageLayout,
  SupportButton,
  AlphaDisclaimerInfo,
  Content,
  Link as TMNALink,
  EmptyDataMessage,
  SupportTextList,
  SupportLinks,
 // SupportLinkCard,
  SupportMultipleLinkCard
} from 'tmna-ui-kit';
import { EntityFilterGroupsProvider, useFilteredEntities } from '../../filter';
import { registerComponentRouteRef } from '../../routes';
import { ResultsFilter } from '../ResultsFilter/ResultsFilter';
import { ButtonGroup, useFilter } from '../ScaffolderFilter';
//import SearchToolbar from '../SearchToolbar/SearchToolbar';
import { TemplateCard } from '../TemplateCard';
//import VideocamIcon from '@material-ui/icons/Videocam';
// import SortIcon from '@material-ui/icons/Sort';
import DescriptionIcon from '@material-ui/icons/Description';
import { useAsync } from 'react-use';



import { configApiRef, useApi, useRouteRef } from '@backstage/core-plugin-api';
import { ContentHeader, Progress, WarningPanel } from '@backstage/core-components';
import { scaffolderApiRef } from '../../api';


const useStyles = makeStyles(theme => ({
  contentWrapper: {
    //display: 'grid',
    // display: 'grid',
    gridTemplateAreas: "'filters' 'grid'",
    gridTemplateColumns: '290px 1fr',
    gridColumnGap: theme.spacing(4),
    height: '300px'
  },
  formControl: {
    width: '250px',
    // marginBottom: '20px',
    // marginLeft: 'auto',
    display: 'flex',
    // top: '-153px'

  },
  sortContainer: {
    marginTop: '55px',
    width: '200px',
    marginRight: '70px'
  },
  filterSection: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  boxMuiOverride: {
    marginBottom: '0px'
  },
  heading: {
    paddingTop: '8px'
  },
  divider: {
    marginTop: '-42px',
    marginBottom: '34px'
  },
  categoriesTitle: {
    padding: theme.spacing(2, 0),
    fontSize: '12px',
  },
  card: {
    maxHeight: '430px',

    '&:hover': {
      boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.2)',
      cursor: 'pointer',
    }
  },
  warCard: {
    width: '1140px',
    maxHeight: '580px',
    marginLeft: '-20px',
  },
  content: {
    padding: theme.spacing(3),
  },
  type: {
    textTransform: 'capitalize',
    display: 'block',
    marginLeft: '25px',
    marginTop: '25px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    // paddingTop: theme.spacing(1.5),
    // paddingBottom: theme.spacing(3),
  },
  titleWarRightGrid: {
    fontSize: '14px',
    marginTop: '-20px'
  },
  warDescription: {
    fontSize: '14px',
    marginTop: '-50px'
  },
  preRequisites: {
    marginTop: '20px',
    fontSize: '14px',
    font: 'bold'
  },
  titleWarRightGridDesc: {

    fontSize: '13px',
    marginTop: '3px'
  },
  description: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 10,
    '-webkit-box-orient': 'vertical',
    width: '320px',
    marginLeft: '20px'
  },
  arrowIcon: {
    position: 'relative',
    top: '3px',
    marginLeft: theme.spacing(0.5),
  },
  cardActions: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderTop: 'none',
  },
  leftButton: {
    marginRight: 'auto',
  },
  createButton: {
    marginRight: 'auto',
    borderRadius: '50px',
    backgroundColor: 'RGBA(0,53,89,1)'
  },
  createButtonMargin: {
    marginLeft: '24px',
    marginTop: '130px'

  },
  root: {
    maxWidth: 345,
  },
  // divider: {
  //   height: '100%',
  //   backgroundColor: 'RGBA(0,53,89,1)',
  //   // margin: theme.spacing(5, 0),
  //   width: '2px'
  // },
  closeButton: {
    position: 'relative',
    // bottom: '180px',
    marginLeft: '660px',
    marginTop: '3px'
  },
  gridItem: {
    width: '380px',
  },
  gridItem1: {
    width: '700px',
  },
  grid: {
    marginBottom: '5px'
  },
  createWarButton: {
    // marginRight: 'auto',
    borderRadius: '15px',
    background: 'none',
    color: '#eb0a1e',
    border: '2px solid #eb0a1e',
    fontSize: '10px',
    innerHeight: '20px',
    margin: '0px 3px',
    height: '25px',
    textTransform: 'capitalize',
    cursor: 'none'
  },
  createWarButtonMargin: {
    marginLeft: '10px',
    marginTop: '10px',
    textTransform: 'lowercase',
    fontSize: '16px',
  },
  InfoIcon: {
    marginLeft: '280px',
    marginTop: '-25px',
    cursor: 'pointer'
  },
  pushPin: {
    marginLeft: '340px',
    marginTop: '-10px'
  },
  operationalText: {
    marginTop: '20px'
  },
  operationalWarScore: {
    marginLeft: '230px',
    marginTop: '-20px'
  },
  securityWarScore: {
    marginLeft: '230px',
    // marginTop: '-75px'
  },
  securityText: {
    marginTop: '-20px'
  },
  reliabilityWarScore: {
    marginLeft: '230px',
    marginTop: '-60px'
  },
  reliabiltyText: {
    marginTop: '-30px'
  },
  performanceWarScore: {
    marginLeft: '230px',
    marginTop: '-60px'
  },
  performanceText: {
    marginTop: '-30px'
  }
}));

//const COMPONENT_CREATION_SUPPORT_LINK = 'https://web.microsoftstream.com/video/ce80ab11-34ac-494d-9352-2f324415083b?list=studio';
const RELATED_DOCS_SUPPORT_LINKS = [
  {
    to: '/docs/default/Component/ACE-TECH-DOCS/blueprints/overview/',
    title: 'Overview of Blueprints',
  },
  {
    to: '/docs/default/Component/ACE-TECH-DOCS/blueprints/getting-started/',
    title: 'Getting Started with Blueprints',
  },
  {
    to: '/docs/default/Component/ACE-FAQ/Blueprints/blueprints-templates-are-failing-to-publish/',
    title: 'Troubleshooting Blueprints',
  }
];

const RELATED_DOCS_SUPPORT_LINKS_SELF_SERVICE = [
  {
    to:'https://teams.microsoft.com/l/channel/19%3a5_ymJwJxEJhMuJL-7nDZIwzFmaHA2UV7dM1GUxtLbNs1%40thread.tacv2/General?groupId=4ae2a04b-2ce1-499a-8d31-9aee65ec87b5&tenantId=8c642d1d-d709-47b0-ab10-080af10798fb',
    title:'For questions, reach out to Chofer Care channel',
  }
]


const StyledTooltip = withStyles({
  tooltip: {
    background: 'transparent',
    color: 'black',
    marginTop: 0
  },
})(Tooltip);
interface ChildComponentBProps {
  selfServiceParam?: MyData;
}
interface MyData {
  selfService?: boolean;
  selfServiceTitle?: string;
  selfServiceCategories?: string[];
}
interface ChildComponentAProps {
  selfServiceData?: MyData;
}
const excludedCategories = ["Cloud-Onboarding","Datadog-Onboarding"];
const ScaffolderPageContents: React.FC<ChildComponentBProps>  = ({selfServiceParam}) => {
  const styles = useStyles();
  const {
    loading,
    error,
    filteredEntities,
    availableCategories,
    availableTags,
    availableCsp
  } = useFilteredEntities();

  // const availableCsp = ["AWS","GCP"]
  const availableStatus = ["Published", "Preview", "Prioritized"]
  const customCategories:string[] | any = selfServiceParam?.selfService ? selfServiceParam.selfServiceCategories : availableCategories.filter(category => !excludedCategories.includes(category));
  const configApi = useApi(configApiRef);
  const scaffolderApi = useApi(scaffolderApiRef);
  const orgName = configApi.getOptionalString('organization.name') ?? 'Company';
  const { isStarredEntity } = useStarredEntities();
  const [isExpanded2, setIsExpanded2] = React.useState(false);

  const toggleContents = React.useCallback(() => {
    setIsExpanded2(!isExpanded2);
  }, [isExpanded2]);

  const { value: templateData } = useAsync(() => {
    return scaffolderApi.getMostPoulartData();
  }, [scaffolderApi]);

  const filterGroups = useMemo<ButtonGroup[]>(
    () => [
      {
        name: orgName,
        items: [
          {
            id: 'all',
            label: 'All',
            filterFn: () => true,
          },
        ],
      },
      {
        name: 'Personal',
        items: [
          {
            id: 'starred',
            label: 'Starred',
            icon: StarIcon,
            filterFn: isStarredEntity,
          },
        ],
      },
    ],
    [isStarredEntity, orgName],
  );
  const [search] = useState('');
  const [matchingEntities, setMatchingEntities] = useState(
    [] as TemplateEntityV1beta3[],
  );

  // const [localStorageArray, setlocalStorageArray] = useState(
  //   [] as any,
  // );

  // const localStorageArray = (data :any) => {
  //   console.log ("data",data);
  // };

  // const [clickedIndex , setClickedIndex]= useState(0);
  //const [openCard, setOpenCard] = React.useState(false);
  const [selectedSort, setSelectedSort] = useState('');
  const [oldMatchingEntities, setoldMatchingEntities] = useState(
    [] as TemplateEntityV1beta3[],);
  React.useEffect(() => {
    document.title = selfServiceParam?.selfService ? 'Self Service':'Blueprints';
  }, []);
  const handleSelectedIndex = (index: any) => {
    //setOpenCard(true)
    //console.log("event target value", index);

    var matchingEntitiesTemp = Object.assign({}, matchingEntities);
    if (index % 3 === 1) {
      //[arrtemp[3], arrtemp[4]] = [arr[4], arr[3]];
      [matchingEntitiesTemp[index], matchingEntitiesTemp[index - 1]] = [matchingEntitiesTemp[index - 1], matchingEntities[index]];

    } else if (index % 3 === 2) {
      [matchingEntitiesTemp[index], matchingEntitiesTemp[index - 1], matchingEntitiesTemp[index - 2]] = [matchingEntities[index - 2], matchingEntities[index - 1], matchingEntities[index]];
    } else if (index % 3 === 0) {
      // To Do nothing

    }

    setMatchingEntities(Object.values(matchingEntitiesTemp));
    //console.log("matching entities", matchingEntitiesTemp)

    // // if grid is 4
    // if (index % 4 === 1) {
    //   //[arrtemp[3], arrtemp[4]] = [arr[4], arr[3]];
    //   [matchingEntitiesTemp[index], matchingEntitiesTemp[index - 1]] = [matchingEntitiesTemp[index - 1], matchingEntities[index]];

    // } else if (index % 4 === 2) {
    //   [matchingEntitiesTemp[index], matchingEntitiesTemp[index - 1], matchingEntitiesTemp[index - 2]] = [matchingEntities[index - 2], matchingEntities[index - 1], matchingEntities[index]];
    // } else if (index % 4 === 3) {
    //   [matchingEntitiesTemp[index], matchingEntitiesTemp[index - 1], matchingEntitiesTemp[index - 2], matchingEntitiesTemp[index - 3]] = [matchingEntities[index - 3], matchingEntities[index - 2], matchingEntities[index - 1], matchingEntities[index]];
    // }
    // else if (index % 4 === 0) {
    //   // To Do nothing
    // }
  }

  const getFinalEntity = (filteredEntities: any[]) => {
    return selfServiceParam?.selfService
      ? filteredEntities.filter(template =>
          selfServiceParam?.selfServiceCategories?.includes(template.spec.type),
        )
      : filteredEntities.filter(
          template => !excludedCategories?.includes(template.spec.type),
        );
  };
  const handleSortChange = (event: any) => {
    setSelectedSort(event.target.value);
    const finalEntitiesSort = getFinalEntity(filteredEntities);
    if (event.target.value === 'AtoZ') {
      return setMatchingEntities(
        finalEntitiesSort.sort((a: any, b: any) =>
          a.metadata?.title.localeCompare(b.metadata?.title),
        ),
      );
    } else if (event.target.value === 'ZtoA') {
      return setMatchingEntities(
        finalEntitiesSort.sort(
          (a: any, b: any) =>
            -a.metadata?.title.localeCompare(b.metadata?.title),
        ),
      );
    } else if (event.target.value === 'Newest First') {
      return setMatchingEntities(
        finalEntitiesSort.sort(
          (a: any, b: any) =>
            new Date(
              b.metadata?.date ? b.metadata?.date : new Date(),
            ).valueOf() -
            new Date(
              a.metadata?.date ? a.metadata?.date : new Date(),
            ).valueOf(),
        ),
      );
    } else if (event.target.value === 'Oldest First') {
      return setMatchingEntities(
        finalEntitiesSort.sort(
          (a: any, b: any) =>
            new Date(
              a.metadata?.date ? a.metadata?.date : new Date(),
            ).valueOf() -
            new Date(
              b.metadata?.date ? b.metadata?.date : new Date(),
            ).valueOf(),
        ),
      );
    } else if (event.target.value === 'Most Popular') {
      const templateCountData = finalEntitiesSort.map((t1: any) => ({
        ...t1,
        ...(templateData?.find(
          (t2: any) => t2.blueprintTemplate === t1.metadata?.title,
        ) as any),
      }));
      return setMatchingEntities(
        templateCountData.sort(
          (a: any, b: any) => parseInt(b.count || 0) - parseInt(a.count || 0),
        ),
      );
    }
  };
  const contentTitle = React.useCallback(() => (
    <Typography variant="h2">
      Available Blueprints
    </Typography>
  ), []);
  useFilter(
    filterGroups,
    'all',
  );

  const matchesQuery = (metadata: EntityMeta, query: string) =>
    `${metadata.title}`.toLocaleUpperCase('en-US').includes(query) ||
    metadata.tags?.join('').toLocaleUpperCase('en-US').indexOf(query) !== -1;

  const registerComponentLink = useRouteRef(registerComponentRouteRef);

  const addingTemplatesLink = React.useMemo(() => (
    <TMNALink
      to="https://backstage.io/docs/features/software-templates/adding-templates"
      type="text"
    >
      adding templates
    </TMNALink>
  ), []);

  useEffect(() => {
    //setlocalStorageArray(filteredEntities);
    const finalEntities = getFinalEntity(filteredEntities);
    setoldMatchingEntities(finalEntities)
    if (search.length === 0) {
      return setMatchingEntities(finalEntities);
    }
    return setMatchingEntities(
      finalEntities.filter((template: { metadata: EntityMeta; }) =>
        matchesQuery(template.metadata, search.toLocaleUpperCase('en-US')),
      ),
    );


  }, [search, filteredEntities,selfServiceParam]);

  return (
    <PageLayout
      title={
        selfServiceParam?.selfService
          ? 'Chofer Self Service'
          : 'Create a New Component'
      }
      subtitle={
        selfServiceParam?.selfService
          ? 'Provision Chofer services using self service templates'
          : 'Create new software components using standard blueprints'
      }
      headerBackgroundImg="assets/create_bg.png"
      displayButton={true}
    >
      <Content>
        <div>
          {!selfServiceParam?.selfService && <div className={styles.filterSection}>
            <div className={styles.heading}>
                <Typography variant="h3"> Available Blueprints</Typography>
            </div>

            <Box mb={4} style={{ display: 'flex' }}>
                <Box>
                  <div style={{ marginTop: '10px', cursor: 'pointer' }}>
                    <div
                      data-testid="BlueprintIconToggle"
                      onClick={toggleContents}
                    >
                      <StyledTooltip
                        placement="bottom"
                        title={
                          <div>
                            <div>What is a</div>
                            <div>blueprint?</div>
                          </div>
                        }
                      >
                        <div
                          style={{
                            //color: 'white' ,
                            backgroundColor: isExpanded2 ? 'red' : '',
                            color: isExpanded2 ? 'white' : 'red',
                            borderRadius: '.8em',
                          }}
                        >
                          <HelpOutlineIcon />
                        </div>
                      </StyledTooltip>
                    </div>
                  </div>
                </Box>

              <Box mb={0} className={styles.boxMuiOverride}>
                <ContentHeader titleComponent={contentTitle}>
                  {registerComponentLink && (
                    <Button
                      component={RouterLink}
                      variant="contained"
                      color="primary"
                      to={registerComponentLink()}
                    >
                      Register Existing Component
                    </Button>
                  )}
                  <SupportButton>
                      <SupportTextList>
                        <Typography variant="body2">
                          Production ready solution components that provision
                          cloud resources aligned with TMNA corporate standards
                          and policies.
                        </Typography>
                      </SupportTextList>
                    <SupportLinks>
                        <SupportMultipleLinkCard
                          icon={<DescriptionIcon />}
                          title="Related Docs"
                          items={RELATED_DOCS_SUPPORT_LINKS}
                        />
                    </SupportLinks>
                  </SupportButton>
                </ContentHeader>
              </Box>
            </Box>
          </div>}
        </div>
        {isExpanded2 && (
          <Box mb={5}>
            <AlphaDisclaimerInfo closeContents={() => setIsExpanded2(false)} />
          </Box>
        )}

        {selfServiceParam?.selfService && <Grid item style={{ textAlign: 'end' }}>
          <div>
            <SupportButton>
              <SupportLinks>
                  <SupportMultipleLinkCard
                    icon={<DescriptionIcon />}
                    title="Contact Us"
                    items={RELATED_DOCS_SUPPORT_LINKS_SELF_SERVICE}
                  />
              </SupportLinks>
            </SupportButton>
          </div>
        </Grid>}

        <div className={styles.contentWrapper}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <div>
                <ResultsFilter
                  availableCategories={customCategories}
                  availableCsp={availableCsp}
                  availableStatus={availableStatus}
                  availableTags={availableTags}
                  selectedSort={selectedSort}
                  setSelectedSort={setSelectedSort}
                  selfServiceResultParam={selfServiceParam?.selfService}
                />
              </div>
            </Grid>
            <Grid item className={styles.sortContainer}>
              <div>
                <FormControl variant="outlined" className={styles.formControl}>
                  <Typography
                    variant="button"
                    component="div"
                    className={styles.categoriesTitle}
                  >
                    Sort
                  </Typography>
                  <Select
                    value={selectedSort}
                    onChange={handleSortChange}
                    IconComponent={() => (
                      <SortIcon
                        style={{ marginRight: '5px', color: 'red' }}
                        fontSize="medium"
                      />
                    )}
                  >
                    <MenuItem value="">Sort</MenuItem>
                    <MenuItem value="AtoZ">A to Z</MenuItem>
                    <MenuItem value="ZtoA">Z to A</MenuItem>
                    <MenuItem value="Most Popular">Most Popular</MenuItem>
                    <MenuItem value="Newest First">Newest to Oldest</MenuItem>
                    <MenuItem value="Oldest First">Oldest to Newest</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Grid>
          </Grid>
          <div>
            <div style={{ marginTop: '50px' }}>
              {loading && <Progress />}
              {error && (
                <WarningPanel title="Oops! Something went wrong loading the templates">
                  {error.message}
                </WarningPanel>
              )}
              <div className={styles.divider}>
                <Divider />
              </div>
              {!error &&
                !loading &&
                matchingEntities &&
                !matchingEntities.length && (
                  <EmptyDataMessage
                    messageComponent={
                      <Box textAlign="center">
                        <Typography variant="h4" gutterBottom>
                          No templates found that match your filter
                        </Typography>
                        <Typography variant="body1">
                          Learn more about {addingTemplatesLink}.
                        </Typography>
                      </Box>
                    }
                  />
                )}

              {/* <ItemCardGrid> */}
              {/* {console.log("selectedTemplate", openCard)} */}
              <Grid container >
                {matchingEntities &&
                  matchingEntities?.length > 0 &&
                  matchingEntities.map((template, index) => (
                    <TemplateCard
                      key={template.metadata.name}
                      template={template}
                      //setSelectedTemplate={setSelectedTemplate}
                      setMatchingEntities={setMatchingEntities}
                      // localStorageArray={localStorageArray}
                      index={index}
                      //matchingEntities={matchingEntities}
                      oldMatchingEntities={oldMatchingEntities}
                      selectedIndex={handleSelectedIndex}
                      selfServiceParam={selfServiceParam}
                    // openCard={openCard}
                    //selectedIndex = (index) => {console.log("select index ", index)}
                    />
                  ))}
              </Grid>
              {/* </ItemCardGrid> */}
            </div>
          </div>
        </div>
      </Content>
    </PageLayout>
  );
};


export const ScaffolderPage:React.FC<ChildComponentAProps> = ({selfServiceData}) => {
  return (
    <EntityFilterGroupsProvider>
      <ScaffolderPageContents selfServiceParam={selfServiceData} />
    </EntityFilterGroupsProvider>
  )
};

